module.exports = "/images/pw.svg?a7ce19abc787ce4212cf583683a9f7d9";